(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketingTrackerNew.Settings.Integrations",
                {
                    url: "/Integrations",
                    component: "integrations",
                    PageTitle: "Integrations | Marketing Tracker"//,
                    //requiredPermissions: "DataImports:Access",
                    //resolve: {}
                });
        }
    ]);

    app.component("integrations",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/Settings/Integrations/integrations-template.html",
            controller: integrationsCtrl
        });

    integrationsCtrl.$inject = ["$q", "marketingTrackerConstantContactApi", "marketingTrackerActOnApi", "marketingTrackerRMEApi", "marketingTrackerUserApi", "permissionService", "figToaster", "_", "$window", "featureToggleService"];
    function integrationsCtrl($q, marketingTrackerConstantContactApi, marketingTrackerActOnApi, marketingTrackerRMEApi, marketingTrackerUserApi, permissionService, figToaster, _, $window, featureToggleService) {

        var $ctrl = this;        
        ng.extend($ctrl,
            {
                ui: {
                    loading: false,
                    isAdmin: false
                },
                constantContact: {
                    isConnected: false,
                    isVisible: true
                },
                actOn: {
                    isConnected: false,
                    isVisible: true
                },
                rme: {
                    isConnected: false,
                    isVisible: true,
                    customerList: []
                },
                connectToConstantContact: connectToConstantContact,
                connectToRme: connectToRme,
                removeRmeConnection: removeRmeConnection,
                setCustomerNumber: setCustomerNumber,
                connectToActOn: connectToActOn,
                removeActOnConnection: removeActOnConnection,
                removeConstantContactConnection: removeConstantContactConnection
            });

        $ctrl.$onInit = function () {
            $ctrl.toggleFeature = featureToggleService.checkEnv();
            $ctrl.ui.loading = true;

            //var p1 = permissionService.hasOnePermission("MarketingTrackerAdmin:Access");
            var p1 = marketingTrackerUserApi.actingUserIsAdminstrator().catch(ng.noop);
            var p2 = marketingTrackerConstantContactApi.getHasToken();
            var p3 = marketingTrackerRMEApi.getCustomerList().catch(ng.noop);
            var p4 = marketingTrackerRMEApi.getCustomerRecord().catch(ng.noop);
            var p5 = marketingTrackerActOnApi.token().catch(ng.noop);
            $q.all([p1, p2, p3, p4, p5]).then(function (results) {

                $ctrl.ui.isAdmin = results[0] ? true : false;
                $ctrl.constantContact.isConnected = results[1];                
                $ctrl.rme.customerList = results[2];
                $ctrl.rme.isConnected = results[3] ? true : false;

                if ($ctrl.rme.customerList) {                   
                    $ctrl.rme.customerList.unshift({ CustomerName: "Select Customer", CustomerNumber: null });
                    if ($ctrl.rme.isConnected) {
                        setCustomerNumber(results[3].CustomerNumber);
                    }
                    else setCustomerNumber(null);
                }     

                console.log(results[4])
                $ctrl.actOn.isConnected = results[4] && results[4] === true ? true : false;

            }).then(function () {
                $ctrl.ui.loading = false;
            });
        };

        function connectToConstantContact() {
            marketingTrackerConstantContactApi.postConnect()
                .then(function (response) {
                    console.log('Get Authentication URL from Marketing Tracker' + response);
                    //$window.open(response.Url, '_blank');
                    $window.location.href = response.Url;
                });
        }

        function removeConstantContactConnection() {
            marketingTrackerConstantContactApi.removeToken().then(function (response) {
                console.log(response);
                $ctrl.constantContact.isConnected = false;
                return figToaster.showSimple("Constant Contact disconnected.", "top", "is-success");
            });
        }

        function connectToRme(customer) {
            console.log(customer);

            if (customer.CustomerNumber) {
                marketingTrackerRMEApi.connectCustomerRecord(customer).then(function (response) {
                    console.log(response);
                    $ctrl.rme.isConnected = true;
                    $ctrl.rme.customer = customer;
                 
                    return figToaster.showSimple("RME connection successful.", "top", "is-success");
                });
            }
        }

        function setCustomerNumber(customerNumber) {
            $ctrl.rme.customer = _.find($ctrl.rme.customerList, { CustomerNumber: customerNumber });            
        }

        function removeRmeConnection() {

            marketingTrackerRMEApi.removeCustomerRecord().then(function (response) {
                console.log(response);
                $ctrl.rme.isConnected = false;
                     
                setCustomerNumber(null);

                return figToaster.showSimple("RME connection disconnected.", "top", "is-success");
            });
        }

        function connectToActOn() {

            marketingTrackerActOnApi.authorize()
                .then(function (response) {
                    console.log(response);
                    //$window.open(response.Url, '_blank');
                    $window.location.href = response.Url;
                });
        }

        function removeActOnConnection() {
            marketingTrackerActOnApi.disconnect().then(function (response) {
                console.log(response);
                $ctrl.actOn.isConnected = false;               
                return figToaster.showSimple("ActOn connection disconnected.", "top", "is-success");
            });
        }
    }

})(window.app, window.angular); // jshint ignore:line